'use strict';

( function( $ ) {
	class Pagination {
		constructor( $component ) {
			this.$pagination = $component;
			this.$select = $component.find( '[data-pagination="select"]' );

			this.init = this.init.bind( this );

			this.init();
		}

		init() {
			this.$select.on( 'change', e => {
				window.location.href = e.target.value;
			} );
		}
	}

	$.fn.pagination = function() {
		this.each( function() {
			new Pagination( $( this ) );
		} );
	};

	$( '[data-pagination="component"]' ).pagination();
}( jQuery ) );

// Blog Search Filters
const feedAjax = $ => {
	const $filteredFeed = $( '#filtered-feed' );
	let $filters, $feedWrapper, postType, category, taxonomy;
	const $spinner = `
		<div class="spinner-wrapper" id="spinner">
			<div class="spinner-border" role="status">
				<span class="sr-only">Loading...</span>
			</div>
		</div>`;

	const setFilters = () => {
		category = $( '#category-filter' ).val();

		taxonomy = $( '#tag-filter' ).val();
	};

	const getData = () => {
		return new Promise( ( resolve, reject ) => {
			$.ajax( {
				type: 'POST',
				url: '/wp-admin/admin-ajax.php',
				dataType: 'json',
				data: {
					action: 'get_more_ajax',
					postType,
					category,
					taxonomy,
				},
				success: response => {
					return resolve( response );
				},
				error: response => {
					return reject( response );
				},
			} );
		} );
	};

	const updateFeed = () => {
		setFilters();

		$feedWrapper
			.html( '' )
			.append( $spinner );

		getData().then( data => {
			renderFeed( data );
		} ).catch( console.error() );
	};

	const renderFeed = data => {
		$( '#spinner' ).remove();

		window.history.pushState( '', '', '/blog/?&category-filter=' + category + '&topic-filter=' + taxonomy );

		// Add markup
		if ( data.markup === '' ) {
			$feedWrapper.append( '<p class="no-results">No Results Found...</p>' );
		} else {
			$feedWrapper.append( data.markup );
		}
	};

	return {
		init() {
			if ( ! $filteredFeed.length ) {
				return;
			}

			$filters = $filteredFeed.find( '.dropdown-select' );
			$feedWrapper = $filteredFeed.find( '.feed-wrapper' );
			postType = 'post';

			setFilters();

			this.bind();
		},
		bind() {
			$filters.on( 'change', () => {
				updateFeed();
			} );
		}
	};
};

feedAjax( jQuery ).init();

// Google Tag Manager events for native video player
const cfplayer = document.getElementById( 'hero-video' );

cfplayer.addEventListener( 'play', () => {
	console.log( 'playing primary video' );
	dataLayer.push( { 'event': 'Video_Start' } );
} );

var perc25hit = false, perc50hit = false, perc75hit = false, perc100hit = false;

cfplayer.addEventListener( 'timeupdate', () => {
	var perc = cfplayer.currentTime / cfplayer.duration;
	if ( perc > 0.25 && perc < 0.5 && ! perc25hit ) {
		perc25hit = true;
		console.log( 'Video_25 complete' );
		dataLayer.push( { 'event': 'Video_25' } );
	}
	if ( perc > 0.5 && perc < 0.75 && ! perc50hit ) {
		perc50hit = true;
		console.log( 'Video_50 complete' );
		dataLayer.push( { 'event': 'Video_50' } );
	}
	if ( perc > 0.75 && perc < 1 && ! perc75hit ) {
		perc75hit = true;
		console.log( 'Video_75 complete' );
		dataLayer.push( { 'event': 'Video_75' } );
	}
	if ( perc >= .98 && ! perc100hit ) {
		perc100hit = true;
		console.log( 'Video_100 complete' );
		dataLayer.push( { 'event': 'Video_100' } );
	}
} );
